export default __webpack_public_path__ + "static/media/8_Still.c666c545.jpg";